import { createCollection } from '../Collection/Collection.js';
import 'react';
import '../../utils/mergeRefs.js';
import '@emotion/react';

const comboboxCollection = createCollection("Combobox");
const onContains = (item, value) => {
  return item.toLowerCase().includes(value.toLowerCase());
};
const onStart = (item, value) => {
  return item.toLowerCase().startsWith(value.toLowerCase());
};
const COMBOBOX_FILTERS = {
  contains: onContains,
  start: onStart
};

export { COMBOBOX_FILTERS, comboboxCollection };
